import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CarouselProductTransports } from "../../../carousel-product/index.js";
import Highlight from "../../components/highlights/index.js";
import * as S from "./styled.js";
export const MobileMapCoasts = ({ props  })=>{
    const { title , items , viewMore  } = props ?? {};
    return /*#__PURE__*/ _jsxs(S.Coasts, {
        "data-testid": "MapCoasts",
        children: [
            title && /*#__PURE__*/ _jsx(CarouselProductTransports, {
                title: title,
                items: items,
                link: viewMore.link
            }),
            /*#__PURE__*/ _jsx(S.Highlights, {
                children: /*#__PURE__*/ _jsx(Highlight, {
                    props: props
                })
            })
        ]
    });
};
export default MobileMapCoasts;

//# sourceMappingURL=index.js.map